import { Component, componentMixin } from '@resn/gozer-core/component';
import { simplePlaneGeometry, simpleVs } from '@resn/gozer-three/simple-three';
import ThreeObjectMixin from '@resn/gozer-core-mixins/three-object';
import { Mesh, PlaneGeometry, ShaderMaterial, Color } from 'three';

import glslDrawing from '@resn/gozer-glsl/shapes/drawing.glsl';
import glslRect from '@resn/gozer-glsl/shapes/rect.glsl';
import glslRotateUV from '@resn/gozer-glsl/uv/uv-rotate.glsl';
import glslGradient from '@resn/gozer-glsl/functions/gradient.glsl';
import { materialEasyUniforms } from '@resn/gozer-three/simple-three';

@componentMixin(ThreeObjectMixin)
class HeroTopArrow extends Component {
    options = {
        color1: '#E3AEFF',
        color2: '#468DFF',
        gradRotation: 0,
        gradScale: 1,
        useMask: false,
    };

    props = {
        thickness: 1,
        maskAngle: 0,
        alpha: 1,
    };

    async onSetup() {
        const shader = (this.shader = new ShaderMaterial({
            vertexShader: simpleVs,
            fragmentShader: /* glsl */ `
                #define PI 3.141592653589793

                varying vec2 vUv;
                
                ${glslDrawing}
                ${glslRect}
                ${glslGradient}
                ${glslRotateUV}
                    
                uniform sampler2D uTexture;
                uniform float uAlpha;
                uniform float uThickness;
                uniform float uGradRotation;
                uniform float uMaskAngle;
                uniform float uGradScale;
                uniform bool uUseMask;
                
                uniform vec3 uColor1;
                uniform vec3 uColor2;
                
                void main() {
                    vec2 st = vUv;
                    vec2 p = st;
                        p -= 0.5;

                    st = UVRotate(st, uGradRotation);
                    st.y -= 0.5;
                    st.y *= uGradScale;
                    st.y += 0.5;
                    
                    vec3 color = gradient(uColor1, uColor2, clamp(st.y, 0.0, 1.0));
                    float d = rect(p, vec2(0.5), uThickness);
                    float alpha = d * uAlpha;

                    if (uUseMask) {
                        vec2 maskUV = UVRotate(vUv, uGradRotation);
                        alpha *= step(0.5, maskUV.y);
                    }
                    
                    gl_FragColor = vec4(color.rgb, alpha);
                    // gl_FragColor = vec4(color.rgb, d);
                    // gl_FragColor = vec4(vec3(vUv.y), d);
                }`,
            uniforms: {
                uColor1: { value: new Color(this.options.color1) },
                uColor2: { value: new Color(this.options.color2) },
                uGradRotation: { value: this.options.gradRotation },
                uGradScale: { value: this.options.gradScale },
                uThickness: { value: this.props.thickness },
                uAlpha: { value: 1 },
                uUseMask: { value: this.options.useMask },
                uMaskAngle: { value: this.props.maskAngle },
            },
            extensions: { derivatives: true },
            transparent: true,
        }));
        materialEasyUniforms(shader, shader.uniforms);

        const quad = (this.quad = new Mesh(simplePlaneGeometry, shader));
        quad.name = 'HeroTopArrow';
        quad.layers.set(this.options.layer);
        this.object.add(quad);
    }

    setAlpha(val) {
        this.shader.uAlpha = val;
    }

    setThickness(t) {
        this.shader.uThickness = t;
    }

    setMaskAngle(val) {
        this.shader.uMaskAngle = val;
    }
}
export default HeroTopArrow;
